import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { I18nProvider } from "./i18n";
import { AuthCallback } from "./components/AuthCallback";
import GhostBox from "./pages/GhostBox";
import Home from "./pages/Home";
import PaymentResult from "./pages/PaymentResult";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="ghost-root" />;
  return user ? children : <Navigate to="/" replace />;
};

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/session" element={<Protected><GhostBox /></Protected>} />
      <Route path="/payment/success" element={<PaymentResult />} />
      <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <I18nProvider>
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster theme="dark" />
      </AuthProvider>
    </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
